import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ComponentsModule } from '@app/components/components.module';
import { IconsModule } from '@app/app-icons.module';
import { StylesModule } from '@app/styles/styles.module';
import { TabViewModule } from 'primeng/tabview';
import { AccordionModule } from 'primeng/accordion';
import { DialogModule } from 'primeng/dialog';
import { MenuModule } from 'primeng/menu';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { SidebarModule } from 'primeng/sidebar';
import { HeroIconModule, checkCircle, map, chevronDown, chevronUp, arrowLeft, arrowRight } from 'ng-heroicon';
import { TaskListItemComponent } from './task-list-item/task-list-item.component';
import { ProjectsModule } from '@app/projects/projects.module';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { ProjectBoardComponent } from './project-board/project-board.component';
import { SkeletonModule } from 'primeng/skeleton';
import { TooltipModule } from 'primeng/tooltip';

@NgModule({
  declarations: [
    TaskListItemComponent,
    ProjectBoardComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    BrowserAnimationsModule,
    ComponentsModule,
    IconsModule,
    StylesModule,
    TabViewModule,
    AccordionModule,
    DialogModule,
    MenuModule,
    DragDropModule,
    SidebarModule,
    ProjectsModule,
    MatSlideToggleModule,
    SkeletonModule,
    TooltipModule,
    HeroIconModule.withIcons({
      checkCircle,
      map,
      chevronDown,
      chevronUp,
      arrowLeft,
      arrowRight
    })
  ]
})
export class RoadmapModule { }
